export default __webpack_public_path__ + "static/media/phonebg.c73425b8.svg";